var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLylaHexagon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 71,
    viewBox: "0 0 65 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 2.33013C29.641 -0.349365 35.359 -0.349365 40 2.33013L57.476 12.4199C62.117 15.0994 64.976 20.0513 64.976 25.4103V45.5897C64.976 50.9487 62.117 55.9006 57.476 58.5801L40 68.6699C35.359 71.3494 29.641 71.3494 25 68.6699L7.52405 58.5801C2.88303 55.9006 0.0240479 50.9487 0.0240479 45.5897V25.4103C0.0240479 20.0513 2.88303 15.0994 7.52405 12.4199L25 2.33013Z",
    fill: "url(#paint0_linear_3906_4449)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3906_4449",
    x1: 10,
    y1: -2,
    x2: 57.8125,
    y2: 78.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E392FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1AFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLylaHexagon);
export default __webpack_public_path__ + "static/media/lyla-hexagon.9466a59305196fad6541b52a1a61a031.svg";
export { ForwardRef as ReactComponent };